<template>
    <comp-9-prep-adherence :section="9" :page="32" :nextDisabled="nextDisabled">
        <p>
            There are a lot of reasons why people don’t take their PrEP medication regularly. Reasons like forgetting to take it, believing they’re not at risk
            of getting HIV, thinking they’re too busy, or worrying about other people judging them for taking PrEP.
        </p>
        <p>
            On the other side, there are some downsides to not taking PrEP meds on a regular basis. Check all that apply to you.
        </p>
        <v-checkbox
            v-for="downside in prepDownsides"
            :key="downside.id"
            :label="downside.text"
            :value="downside.id"
            v-model="selectedDownsides"
            hide-details
            dense
        ></v-checkbox>
        <v-text-field v-if="showManualResponse" outline single-line type="text" v-model.trim="selectedDownsideResponse"></v-text-field>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, map, forEach } from 'lodash';

export default {
    data: function() {
        return {
            selectedDownsides: [],
            selectedDownsideResponse: null
        };
    },
    computed: {
        prepSelectedDownsides() {
            let prepSelectedDownsides = map(filter(this.prepDownsides, 'selected'), 'id');

            if (prepSelectedDownsides) {
                return prepSelectedDownsides;
            } else return [];
        },
        prepSelectedDownsideResponse() {
            let userEnteredDownside = filter(filter(this.prepDownsides, 'selected'), 'userEntered');

            if (userEnteredDownside.length > 0) {
                return userEnteredDownside[0].response;
            }

            return null;
        },
        showManualResponse() {
            if (filter(filter(this.prepDownsides, 'selected'), 'userEntered').length > 0) {
                return true;
            }

            return false;
        },
        prepDownsides: sync('section9/prepIrregularDownsides')
    },
    methods: {
        nextDisabled() {
            if (this.selectedDownsides.length === 0 || (this.showManualResponse && !this.selectedDownsideResponse)) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        selectedDownsides() {
            forEach(this.prepDownsides, o => {
                if (this.selectedDownsides.includes(o.id)) {
                    o.selected = true;

                    if (o.userEntered) {
                        o.response = this.selectedDownsideResponse;
                    }
                } else {
                    o.selected = false;

                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        selectedDownsideResponse() {
            forEach(this.prepDownsides, o => {
                if (o.userEntered && o.selected) {
                    o.response = this.selectedDownsideResponse;
                }
            });
        }
    },
    mounted() {
        this.selectedDownsides = this.prepSelectedDownsides;
        this.selectedDownsideResponse = this.prepSelectedDownsideResponse;
    }
};
</script>
